<template>
	<div>
		<div class="head">
			<div class="head_img">
				<img src="../assets/boloni.jpg" />
				<ul>
					<li><a href="#" @click="ten()">相关资料</a></li>
					<li><a href="#" @click="nine()">主要原材料及配套厂家资料</a></li>
					<li><a href="#" @click="eight()">检测工具及设备</a></li>
					<li><a href="#" @click="seven()">主要生产设备</a></li>
					<li><a href="#" @click="twelve()">竞品客户信息</a></li>
					<li><a href="#" @click="six()">销售前五名客户</a></li>
					<li><a href="#" @click="five()">付款信息</a></li>
					<li><a href="#" @click="four()">人员信息</a></li>
					<li><a href="#" @click="eleven()">供货产品及产能</a></li>
					<li><a href="#" @click="three()">经营情况</a></li>
					<li><a href="#" @click="two()">基本信息</a></li>
					<li><a href="#" @click="one()">供货类型</a></li>
				</ul>
			</div>
		</div>

		<div class="main">
			<div class="main_title">
				<span>供货产品及产能</span>
			</div>
			<div class="item">
				<span class="item_title">请完善以下信息</span>
			</div>
			<div class="main_info">
				<div class="payment_info el-table">
					<!--       <h3>销售前五名客户（必填评分项，没有请填写无）</h3> -->
					<el-table :data="PeRateFrom" border>
						<el-table-column label="供货产品" :render-header="addRedStar">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.prod"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="产品类别" :render-header="addRedStar">
							<template slot-scope="scope"> 
							<select v-model="scope.row.prod_cat" @change="onProdCatChange(scope.row)">
									<option v-for="item in optionsGhType" :key="item.value" :label="item.label"
										:value="item.value"></option>
							</select>
							</template>
						</el-table-column>
					<el-table-column label="月总产能" :render-header="addRedStar">
						<template slot-scope="scope">
							<el-input placeholder="请输入内容" v-model="scope.row.month_cap"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="剩余产能" :render-header="addRedStar">
						<template slot-scope="scope">
							<el-input placeholder="请输入内容" v-model="scope.row.excess_cap"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="单位" width="100">
						<template slot-scope="scope">
							<input type="text" v-model="scope.row.unit" placeholder="单位" style="width:100%;border:1px solid #dcdfe6;border-radius:4px;padding:0 8px;height:32px;box-sizing:border-box;" />
						</template>
					</el-table-column>
						<el-table-column label="keyId" v-if="false">
							<template slot-scope="scope">
								<el-input placeholder="请输入内容" v-model="scope.row.keyid"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<el-button @click="handleDelete(scope.$index,scope.row.keyid)">删除</el-button>
							</template>
						</el-table-column>
					</el-table> 
				</div>
				<div class="payment_info_button">
					<button type="button" @click="addLine"><span>新增行</span></button>
					<button type="button" @click="openPayment_info()"><span>上一步</span></button>
					<button type="button" style="background-color: #27eaff"
						@click="addProdCap()"><span>保存</span></button>
					<button type="button" @click="nextMain()"><span>下一步</span></button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		getGys,
		addProdCap,
		delProdCap,
		getGhType,
		getProdCap
	} from '../api/LoginApi'
	import {
		goBack
	} from '../utils/Transformation'
	import {
		messageError,
		messageSuCcEss
	} from '../utils/message'
	import 'vue-multiselect/dist/vue-multiselect.min.css';
    import Multiselect from 'vue-multiselect'

	export default {
		components: {
			Multiselect
		},
		name: 'ProductsCapacity',
		data() {
			return {
				PeRateFrom: [{
					gys_no: localStorage.getItem('userName'),
					prod: '',
					prod_cat: '',
					month_cap: '',
					excess_cap: '',
					unit: '',
					keyid: 0,
					show: true
				}],
				optionsGhType: [], // 供货小类列表
				ghdl_data: [], // 供货大类数据存储
				ghtype_data: [], // 供货小类数据存储
			}
		},
		created() {
			this.getPeRaTe()
		},
		mounted() {
			// 页面刷新时清除localStorage
			window.onbeforeunload = function(e) {
				let storage = window.localStorage
				storage.clear()
			}
			// localStorage不存在loginguid则跳到登录页面
			if (!localStorage.getItem('loginguid')) {
				const vm = this
				vm.$router.push({
					path: '/Login'
				})
			}
			// 不允许使用页面返回按钮
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL)
				window.addEventListener('popstate', goBack, false)
			}
		},
		destroyed() {
			window.removeEventListener('popstate', goBack, false)
		},
		methods: {
			 // 给表头加必填符号*
			addRedStar(h, { column }) {
				return [
					h("span", { style: "color: red" }, "*"),
					h("span", " " + column.label),
				];
			},
		// 根据产品类别获取单位
		getUnitValue(prodCat) {
			const option = this.optionsGhType.find(item => item.value === prodCat);
			return option ? option.unit : '';
		},
		// 选择产品类别后自动填充单位（用户仍可手动修改）
		onProdCatChange(row) {
			row.unit = this.getUnitValue(row.prod_cat);
		},
			// 查询数据
			getPeRaTe() {
				
					//获取单据状态
					getGys(localStorage.getItem('userName')).then(res => {
						if (res) {
							// 供货大类转为数组渲染页面
					        this.ghdl_data = JSON.parse(res.gys_ghdl);
							
							if (this.ghdl_data && this.ghdl_data.length > 0) { 
								// 查询供货小类
								getGhType(this.ghdl_data.map(item => encodeURIComponent(item.name.replace("/", ",")))).then(res => { 
									// 清空供货小类数据
									this.optionsGhType.splice(0, this.optionsGhType.length)
									res.forEach(type => {
										this.optionsGhType.push({
											language: type.gh_type,
											name: type.gh_type,
											label: type.gh_type,
											unit: type.unit,
											value: type.gh_type
										})
									})
									console.log("optionsGhType", this.optionsGhType);
								})
							}
							getProdCap(localStorage.getItem('userName')).then(res => {
								if (res.length > 0) {
									this.PeRateFrom = res;
								}
							})

							this.PeRateFrom.bill_status = res.bill_status;
						}
					});
				
			},
			// 上一个页面
			openPayment_info() {
				const vm = this
				vm.$router.push({
					path: '/Operation'
				})
			},
			// 下一个页面
			nextMain() {
				if (this.PeRateFrom.bill_status != '已审核') { 
					//保存数据
					this.addProdCap();
					const vm = this;

					if(this.PeRateFrom.length > 0){
						for(var i = 0; i < this.PeRateFrom.length; i++){
							var item = this.PeRateFrom[i];
							if (item.prod){
								if (!item.prod_cat){
									return messageError('第'+(i+1)+'行[产品内别]不能为空!');
								}
								if (!item.month_cap){
									return messageError('第'+(i+1)+'行[月产能]不能为空!');
								}
								if (!item.excess_cap){
									return messageError('第'+(i+1)+'行[剩余产能]不能为空!');
								}
							}
						}
					}
				}
				const vm = this;
				vm.$router.push({
					path: '/Personnel_info'
				})
			},
			one() {
				const vm = this
				vm.$router.push({
					path: '/GysBasic'
				})
			},
			two() {
				const vm = this
				vm.$router.push({
					path: '/Bas_info'
				})
			},
			three() {
				const vm = this
				vm.$router.push({
					path: '/Operation'
				})
			},
			four() {
				const vm = this
				vm.$router.push({
					path: '/Personnel_info'
				})
			},
			five() {
				const vm = this
				vm.$router.push({
					path: '/Payment_info'
				})
			},
			six() {
				const vm = this
				vm.$router.push({
					path: '/GysCooPeRate'
				})
			},
			seven() {
				const vm = this
				vm.$router.push({
					path: '/GysMainLine'
				})
			},
			eight() {
				const vm = this
				vm.$router.push({
					path: '/GysTestLine'
				})
			},
			nine() {
				const vm = this
				vm.$router.push({
					path: '/GysMateLine'
				})
			},
			ten() {
				const vm = this
				vm.$router.push({
					path: '/GysMate'
				})
			},
			eleven() {
				const vm = this
				vm.$router.push({
					path: '/ProductsCapacity'
				})
			},
			twelve() {
				const vm = this
				vm.$router.push({
					path: '/CompetitorcustInfo'
				})
			},
			// 保存数据
			addProdCap: function() {
				if (this.PeRateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
              
				if(this.PeRateFrom.length > 0){
						for(var i = 0; i < this.PeRateFrom.length; i++){
							var item = this.PeRateFrom[i];
							if (item.prod){
								if (!item.prod_cat){
									return messageError('第'+(i+1)+'行[产品类别]不能为空!');
								}
								if (!item.month_cap){
									return messageError('第'+(i+1)+'行[月总产能]不能为空!');
								}
								if (!item.excess_cap){
									return messageError('第'+(i+1)+'行[剩余产能]不能为空!');
								}
							}
						}
				}

				addProdCap(this.PeRateFrom, localStorage.getItem('userName')).then(res => {
					if (res.code === 200) {
						return messageSuCcEss(res.msg)
					} else {
						return messageError(res.msg)
					}
				})
			},
			// 删除行，删除数据
			handleDelete: function(index, keyId) { // 删除行数
				if (this.PeRateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				if (keyId) {
					delProdCap(keyId).then(res => {
						if (res.code === 200) {
							return messageSuCcEss(res.msg)
						} else {
							return messageError(res.msg)
						}
					})
				}
				this.PeRateFrom.splice(index, 1)
			},
			// 新增行
			addLine: function() { 
				if (this.PeRateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
				}
				let RateValue = {
					gys_no: localStorage.getItem('userName'),
					prod: '',
					prod_cat: '',
					month_cap: '',
					excess_cap: '',
					keyid: 0,
					show: true
				}
				this.PeRateFrom.push(RateValue)
			}
		}
	}
</script>



<style scoped>
	@import "../css/Main.css";
	.required-star::before {
		content: "*";
		color: red;
		margin-right: 4px; /* 根据需要调整间距 */
	}
</style>



// WEBPACK FOOTER //
// src/componentsline/ProductsCapacity.vue